import { FCI_ERROR } from "@searchui-searchforms/shared/fci";
import { fciFetch } from "@/shared/lib/fci";
import type { SaveUserPreferencesBody, SaveUserPreferencesPayload } from "./types";

const saveUserPreferences = async (partnerId: number, body: SaveUserPreferencesBody) => {
    await fciFetch(`/api/search-preferences?partner=${partnerId}`, {
        method: "POST",
        body,
        fci: {
            // POST request to persist user search preferences
            // If it fails, the user's settings are silently lost
            errorType: FCI_ERROR.Action,
            errorInfo: "saveSearchPreferences",
        },
    });
};

export const saveSearchPreferences = async (partnerId: number, formData: SaveUserPreferencesPayload): Promise<void> => {
    await saveUserPreferences(partnerId, {
        givenNameExactness: formData.givenNameExactness,
        surnameExactness: formData.surnameExactness,
        showUnviewedRecordsOnly: formData.showUnviewedRecordsOnly,
        types: formData.types,
        showMoreOptions: formData.showMoreOptions,
        matchAll: formData.matchAllTermsExactly,
        isSkipAssistPlacesModalPermanently: formData.isSkipAssistPlacesModalPermanently,
        collectionFocus: formData.collectionFocus,
    });
};
